let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [],
	smoother;

$(function () {
	new StarterKitMcube();
	new SmoothScroll();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}

	new BannerHome();
	new BlockExpertises();
	new BlockKeyNumbers();
	new Buttons();
	new CardLink();
	new FilterReferences();
	new Nav();
	new Pictures();
	new Quotes();
	new SliderAuto();
	new SliderScrollable();
	new TagCommander();


});
